import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { motion, AnimatePresence } from "framer-motion";
import { X, CreditCard, Mail, Phone, User, Tag, Trash2 } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useAppContext } from "../../context/AppContext";
import { toast } from "sonner";
import { leadBatchApi } from "../../Redux/ReduxSlices/leadBatchSlice";
import NormalLoader from "../customeLoader/NormalLoader";
import {
  dataCountPreview,
  downloadDataCouponCodeValidation,
} from "../../Redux/ReduxSlices/downloadDataSlice";
import { fetchIpData } from "../../Redux/ReduxSlices/newsearchSlice";
import RazorpayPopup from "./RazorpayPopup";
import StripePopup from "./StripePopup";
import { fetchUserDetails } from "../../Redux/ReduxSlices/profileSlice";
import { demoUserIds } from "../../utils/allowedUserIds";

const DownloadDataFormPopup = ({
  isOpen,
  onClose,
  remainingDownload = false,
  remainingDownloadCount = 0,
  remainingSessionId = "",
  remainingBatchId = "",
  remainingDownloadSuccess = () => { },
}) => {
  const {
    promptsDataCompany,
    setViewMode,
    promptsDataPeople,
    viewMode,
    setPromptsDataPeople,
    setShowPromtData,
    setShowUrlData,
    prompt,
    promptInput,
    isSearchLoading,
    setIsSearchLoading,
    loadingMessage,
    setLoadingMessage,
    defaultLocation,
    getContactsCount,
  } = useAppContext();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
  } = useForm();
  const { details: userData } = useSelector((state) => state.profile);
  const [isLaunching, setIsLaunching] = useState(false);
  const [totalLeads, setTotalLeads] = useState(0);
  const [countOptions, setCountOptions] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [originalAmount, setOriginalAmount] = useState(0);
  const [selectedCount, setSelectedCount] = useState(0);
  const [batchId, setBatchId] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [isLoadingAmount, setIsLoadingAmount] = useState(false);
  const { ipData } = useSelector((state) => state.database);
  const [showRazorpayPopup, setShowRazorpayPopup] = useState(false);
  const [showStripePopup, setShowStripePopup] = useState(false);
  const [userFormDetails, setUserFormDetails] = useState(null);

  useEffect(() => {
    dispatch(fetchUserDetails());
  }, []);

  //   const { register: registerCount, watch, setValue } = useForm();

  //   const selectedCountValue = watch("count");

  const countryName =
    localStorage.getItem("user_country_name") ||
    ipData?.data?.country_name ||
    "India";
  const isIndia = countryName.toLowerCase() === "india";
  // const isIndia = false;
  const currency = isIndia ? "INR" : "USD";
  // const currency = "USD";

  // Generate radio button options based on totalLeads
  const generateCountOptions = (total) => {
    const options = [];
    for (let i = 500; i <= total; i += 500) {
      options.push(i);
    }
    return options;
  };

  useEffect(() => {
    if (!remainingDownload) {
      if (totalLeads > 0) {
        setCountOptions(generateCountOptions(totalLeads));
      }
    } else {
      if (remainingDownloadCount > 0) {
        setCountOptions(generateCountOptions(remainingDownloadCount));
      }
    }
  }, [totalLeads, remainingDownloadCount, remainingDownload]);

  //   useEffect(() => {
  //     if (selectedCountValue && selectedCountValue > 0 && batchId) {
  //       onCountSubmit(selectedCountValue);
  //     }
  //   }, [selectedCountValue, batchId]);

  useEffect(() => {
    if (
      (selectedCount > 0 && batchId) ||
      (selectedCount > 0 && remainingBatchId)
    ) {
      onCountSubmit(selectedCount);
    }
  }, [selectedCount, batchId, remainingBatchId]);

  const onSubmit = async (data) => {
    // Store the form data to pass to payment popup
    const userFormData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobile,
    };
    setUserFormDetails(userFormData);

    // Close the download form
    //   onClose();
    // Open appropriate payment popup based on currency
    if (isIndia) {
      setShowRazorpayPopup(true);
    } else {
      setShowStripePopup(true);
    }
  };

  const getFullName = (p) => {
    if (p?.full_name?.trim()) {
      return p.full_name.trim() || null;
    }

    const first = p?.first_name?.trim() || null;

    const combined = `${first}`.trim();
    return combined || null;
  };

  const rawPeopleList =
    promptsDataPeople?.results?.people ||
    promptsDataPeople?.people ||
    promptsDataPeople?.data ||
    promptsDataPeople?.data?.people ||
    promptsDataPeople ||
    [];
  const peopleList = Array.isArray(rawPeopleList) ? rawPeopleList : [];

  const buildItemsBySource = (source, data = []) => {
    if (!Array.isArray(data)) return [];

    if (source === "db") {
      return data
        .filter((p) => typeof p?.email === "string" && p.email.trim() !== "")
        .map((p) => ({
          item: p.email,
          name: getFullName(p),
        }));
    }

    if (source === "api") {
      return data
        .filter((p) => p?.id)
        .map((p) => ({
          item: p.id,
          name: getFullName(p),
        }));
    }

    return [];
  };
  const handelStoreData = async () => {
    try {
      setIsLaunching(true);
      const userId = userData?.data?.id;

      const sessionId = localStorage.getItem("sessionId");

      if (!sessionId) {
        toast.error("Session not found. Please run the prompt again.");
        return;
      }

      const source = promptsDataPeople?.source;
      if (!source) {
        toast.error("Unable to detect data source.");
        return;
      }

      const data =
        (Array.isArray(promptsDataPeople?.data) && promptsDataPeople.data) ||
        (Array.isArray(promptsDataPeople?.results?.people) &&
          promptsDataPeople.results.people) ||
        (Array.isArray(promptsDataPeople?.people) &&
          promptsDataPeople.people) ||
        peopleList ||
        [];
      const leads = buildItemsBySource(source, data);
      setTotalLeads(leads.length);

      const payload = {
        user_id: userId,
        session_id: sessionId,
        prompt: promptInput,
        source,
        items: leads.map((l) => l.item),
        names: leads.map((l) => l.name),
      };

      const response = await dispatch(leadBatchApi(payload)).unwrap();
      setBatchId(response.batch_id);

      toast.success("Data loaded successfully! Please select count.");
    } catch (err) {
      toast.error(err?.message || "Failed to create lead batches");
      reset();
      onClose();
    } finally {
      setIsLaunching(false);
    }
  };

  const onCountSubmit = async (count) => {
    try {
      setIsLoadingAmount(true);
      const sessionId = localStorage.getItem("sessionId");
      const payload = {
        session_id: !remainingDownload ? sessionId : remainingSessionId,
        batch_id: !remainingDownload ? batchId : remainingBatchId,
        count: count,
        currency: currency,
      };

      const response = await dispatch(dataCountPreview(payload)).unwrap();
      if (response.success) {
        setSelectedCount(count);
        setPaymentAmount(response.data.total_amount);
        setOriginalAmount(response.data.total_amount);
        // Reset coupon when count changes
        setAppliedCoupon(null);
        setCouponCode("");
      }
    } catch (error) {
      // Check if error has the specific message format
      const errorMessage = error?.message || error?.detail || "";
      // Pattern to match: "Requested count X is greater than remaining contacts Y"
      const match = errorMessage.match(
        /Requested count (\d+) is greater than remaining contacts (\d+)/,
      );

      if (match) {
        const requestedCount = match[1];
        const remainingContacts = match[2];
        toast.error(
          `You requested ${requestedCount} contacts, but only ${remainingContacts} are remaining. Please select a lower count.`,
        );
      } else {
        // Fallback to generic error message
        toast.error(errorMessage || "Failed to get payment details");
      }
    } finally {
      setIsLoadingAmount(false);
    }
  };

  const applyCoupon = async () => {
    if (!couponCode.trim()) {
      toast.error("Please enter a coupon code");
      return;
    }

    try {
      setIsApplyingCoupon(true);
      const sessionId = localStorage.getItem("sessionId");

      const payload = {
        session_id: sessionId,
        batch_id: batchId,
        count: selectedCount,
        currency: currency,
        coupon_code: couponCode,
      };

      const response = await dispatch(
        downloadDataCouponCodeValidation(payload),
      ).unwrap();

      if (response.success) {
        setPaymentAmount(response.data.final_amount);
        setAppliedCoupon({
          code: response.data.coupon_code,
          discount:
            response.data.original_amount_minor -
            response.data.final_amount_minor,
          discountAmount: response.data.discount_amount_minor / 100,
        });
        setCouponCode(response.data.coupon_code);
        toast.success(response.data.message || "Coupon applied successfully!");
      } else {
        toast.error(response.message || "Invalid coupon code");
        setCouponCode("");
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error?.message || "Failed to apply coupon");
      setCouponCode("");
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  const removeCoupon = () => {
    setPaymentAmount(originalAmount);
    setAppliedCoupon(null);
    setCouponCode("");
    toast.success("Coupon removed");
  };

  useEffect(() => {
    if (isOpen) {
      setAppliedCoupon(null);
      setCouponCode("");
      setSelectedCount(0);
      setPaymentAmount(0);
      if (!remainingDownload) {
        handelStoreData();
      }
    }
  }, [isOpen]);

  if (isLaunching) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600 animate-pulse">
        <NormalLoader />
      </div>
    );
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.2 }}
            className="w-[60vw] max-md:w-full"
          >
            <div className="bg-white backdrop-blur-sm rounded-xl shadow-2xl border overflow-hidden max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between px-5 py-2 bg-white sticky top-0 z-10">
                <div className="flex items-center gap-2">
                  <h2 className="text-lg font-semibold text-indigo-900 mb-0">
                    Get Your Data
                  </h2>
                </div>
                <button
                  onClick={onClose}
                  className="rounded-lg hover:bg-indigo-100 transition-colors"
                >
                  <X className="h-5 w-5 text-indigo-600" />
                </button>
              </div>

              <div className="px-5 py-4 bg-white border-t border-b">
                <div className="space-y-2">
                  <div className="flex items-start gap-2">
                    <p className="text-xs text-gray-700">
                      <span className="font-medium text-blue-700">1.</span> Here
                      you will get CSV file of all emails of the mentioned data
                    </p>
                  </div>
                  <div className="flex items-start gap-2">
                    <p className="text-xs text-gray-700">
                      <span className="font-medium text-blue-700">2.</span> You
                      will have to make the payment for this
                    </p>
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmit(onSubmit)} className="p-5 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Please select the count of how many contacts would you like
                    to download
                  </label>

                  <div className="grid grid-cols-2 gap-2 mt-2">
                    {/* Hardcoded 100 contacts radio button - Show First */}
                    {demoUserIds.includes(userData?.data?.id) && (
                      <>
                        {!remainingDownload && totalLeads > 2 && (
                          <label
                            className={`flex items-center space-x-3 p-2 rounded-lg cursor-pointer border ${selectedCount === 2
                              ? "border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200"
                              : "border-gray-100 hover:bg-gray-50"
                              }`}
                          >
                            <input
                              type="radio"
                              value={2}
                              checked={selectedCount === 2}
                              onChange={() => setSelectedCount(2)}
                              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500"
                            />
                            <span
                              className={`text-sm ${selectedCount === 2 ? "text-indigo-700 font-medium" : "text-gray-700"}`}
                            >
                              2 contacts
                            </span>
                          </label>
                        )}

                        {/* Hardcoded 2 contacts radio button for remaining download - Show First */}
                        {remainingDownload && remainingDownloadCount > 2 && (
                          <label
                            className={`flex items-center space-x-3 p-2 rounded-lg cursor-pointer border ${selectedCount === 2
                              ? "border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200"
                              : "border-gray-100 hover:bg-gray-50"
                              }`}
                          >
                            <input
                              type="radio"
                              value={2}
                              checked={selectedCount === 2}
                              onChange={() => setSelectedCount(2)}
                              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500"
                            />
                            <span
                              className={`text-sm ${selectedCount === 2 ? "text-indigo-700 font-medium" : "text-gray-700"}`}
                            >
                              2 contacts
                            </span>
                          </label>
                        )}
                      </>
                    )}
                    {!remainingDownload && totalLeads > 100 && (
                      <label
                        className={`flex items-center space-x-3 p-2 rounded-lg cursor-pointer border ${selectedCount === 100
                          ? "border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200"
                          : "border-gray-100 hover:bg-gray-50"
                          }`}
                      >
                        <input
                          type="radio"
                          value={100}
                          checked={selectedCount === 100}
                          onChange={() => setSelectedCount(100)}
                          className="h-4 w-4 text-indigo-600 focus:ring-indigo-500"
                        />
                        <span
                          className={`text-sm ${selectedCount === 100 ? "text-indigo-700 font-medium" : "text-gray-700"}`}
                        >
                          100 contacts
                        </span>
                      </label>
                    )}

                    {/* Hardcoded 100 contacts radio button for remaining download - Show First */}
                    {remainingDownload && remainingDownloadCount > 100 && (
                      <label
                        className={`flex items-center space-x-3 p-2 rounded-lg cursor-pointer border ${selectedCount === 100
                          ? "border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200"
                          : "border-gray-100 hover:bg-gray-50"
                          }`}
                      >
                        <input
                          type="radio"
                          value={100}
                          checked={selectedCount === 100}
                          onChange={() => setSelectedCount(100)}
                          className="h-4 w-4 text-indigo-600 focus:ring-indigo-500"
                        />
                        <span
                          className={`text-sm ${selectedCount === 100 ? "text-indigo-700 font-medium" : "text-gray-700"}`}
                        >
                          100 contacts
                        </span>
                      </label>
                    )}

                    {/* Regular count options (500, 1000, 1500, etc.) */}
                    {countOptions.map((option) => (
                      <label
                        key={option}
                        className={`flex items-center space-x-3 p-2 rounded-lg cursor-pointer border ${selectedCount === option
                          ? "border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200"
                          : "border-gray-100 hover:bg-gray-50"
                          }`}
                      >
                        <input
                          type="radio"
                          value={option}
                          checked={selectedCount === option}
                          onChange={() => setSelectedCount(option)}
                          className="h-4 w-4 text-indigo-600 focus:ring-indigo-500"
                        />
                        <span
                          className={`text-sm ${selectedCount === option ? "text-indigo-700 font-medium" : "text-gray-700"}`}
                        >
                          {option.toLocaleString("en-IN")} contacts
                        </span>
                      </label>
                    ))}

                    {/* All contacts option - Show Last */}
                    <label
                      className={`flex items-center space-x-3 p-2 rounded-lg cursor-pointer border ${(
                        !remainingDownload
                          ? selectedCount === totalLeads
                          : selectedCount === remainingDownloadCount
                      )
                        ? "border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200"
                        : "border-gray-100 hover:bg-gray-50"
                        }`}
                    >
                      <input
                        type="radio"
                        value={
                          !remainingDownload
                            ? totalLeads
                            : remainingDownloadCount
                        }
                        checked={
                          !remainingDownload
                            ? selectedCount === totalLeads
                            : selectedCount === remainingDownloadCount
                        }
                        onChange={() =>
                          setSelectedCount(
                            !remainingDownload
                              ? totalLeads
                              : remainingDownloadCount,
                          )
                        }
                        className="h-4 w-4 text-indigo-600 focus:ring-indigo-500"
                      />
                      <span
                        className={`text-sm ${(
                          !remainingDownload
                            ? selectedCount === totalLeads
                            : selectedCount === remainingDownloadCount
                        )
                          ? "text-indigo-700 font-medium"
                          : "text-gray-700"
                          }`}
                      >
                        All (
                        {!remainingDownload
                          ? totalLeads.toLocaleString("en-IN")
                          : remainingDownloadCount.toLocaleString("en-IN")}{" "}
                        contacts)
                      </span>
                    </label>
                  </div>
                </div>

                {/* Amount Display - Shows after count selection */}
                {selectedCount > 0 && (
                  <>
                    {isLoadingAmount ? (
                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200 shadow-sm">
                        <div className="text-center">
                          <div className="animate-pulse">
                            <div className="h-4 bg-blue-200 rounded w-24 mx-auto mb-2"></div>
                            <div className="h-8 bg-blue-200 rounded w-32 mx-auto"></div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200 shadow-sm">
                        <div className="text-center">
                          <p className="text-sm text-gray-600 mb-1">
                            Total Amount
                          </p>
                          <p className="text-3xl font-bold text-indigo-600">
                            {currency === "INR" ? "₹" : "$"}
                            {paymentAmount.toLocaleString("en-IN")}
                          </p>
                          <p className="text-xs text-gray-500 mt-1">
                            For {selectedCount.toLocaleString("en-IN")} contacts
                          </p>
                          {originalAmount !== paymentAmount && (
                            <p className="text-xs text-green-600 mt-1 line-through">
                              Original: {currency === "INR" ? "₹" : "$"}
                              {originalAmount.toLocaleString("en-IN")}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* Personal Details Form - Always visible */}
                <div className="border-t pt-4 mt-2">
                  <h3 className="text-sm font-semibold text-gray-700 mb-3">
                    Personal Details
                  </h3>

                  <div className="grid grid-cols-2 gap-3">
                    <div className="mb-2">
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        First Name <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-indigo-400" />
                        <input
                          {...register("firstName", {
                            required: "First name is required",
                          })}
                          type="text"
                          placeholder="John"
                          className="w-full pl-9 pr-3 py-2 text-sm border border-indigo-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/80"
                        />
                      </div>
                      {errors.firstName && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.firstName.message}
                        </p>
                      )}
                    </div>

                    <div className="mb-2">
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Last Name <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-indigo-400" />
                        <input
                          {...register("lastName", {
                            required: "Last name is required",
                          })}
                          type="text"
                          placeholder="Doe"
                          className="w-full pl-9 pr-3 py-2 text-sm border border-indigo-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/80"
                        />
                      </div>
                      {errors.lastName && (
                        <p className="text-xs text-red-500 mt-1">
                          {errors.lastName.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="mb-2">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-indigo-400" />
                      <input
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                        type="email"
                        placeholder="john.doe@example.com"
                        className="w-full pl-9 pr-3 py-2 text-sm border border-indigo-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/80"
                      />
                    </div>
                    {errors.email && (
                      <p className="text-xs text-red-500 mt-1">
                        {errors.email.message}
                      </p>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Mobile Number <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-indigo-400" />
                      <input
                        {...register("mobile", {
                          required: "Mobile number is required",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Enter a valid 10-digit mobile number",
                          },
                        })}
                        type="tel"
                        placeholder="9876543210"
                        className="w-full pl-9 pr-3 py-2 text-sm border border-indigo-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/80"
                      />
                    </div>
                    {errors.mobile && (
                      <p className="text-xs text-red-500 mt-1">
                        {errors.mobile.message}
                      </p>
                    )}
                  </div>
                  {/* Amount Display - Shows after count selection */}
                  {selectedCount > 0 && (
                    <>
                      {isLoadingAmount ? (
                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200 shadow-sm">
                          <div className="text-center">
                            <div className="animate-pulse">
                              <div className="h-4 bg-blue-200 rounded w-24 mx-auto mb-2"></div>
                              <div className="h-8 bg-blue-200 rounded w-32 mx-auto"></div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          {/* Coupon Field */}
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">
                              Apply Coupon (if any)
                            </label>
                            <div className="flex gap-2">
                              <div className="relative flex-1">
                                <Tag className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-indigo-400" />
                                <input
                                  type="text"
                                  value={couponCode}
                                  onChange={(e) =>
                                    setCouponCode(e.target.value.toUpperCase())
                                  }
                                  placeholder="Enter coupon code"
                                  disabled={!!appliedCoupon}
                                  readOnly={!!appliedCoupon}
                                  className={`w-full pl-9 pr-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/80 ${appliedCoupon
                                    ? "border-green-500 bg-green-50 text-green-700 font-medium"
                                    : "border-indigo-200"
                                    } disabled:bg-gray-100 disabled:cursor-not-allowed`}
                                />
                              </div>
                              {!appliedCoupon ? (
                                <button
                                  type="button"
                                  onClick={applyCoupon}
                                  disabled={
                                    isApplyingCoupon || !couponCode.trim()
                                  }
                                  className="px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                  {isApplyingCoupon ? "Applying..." : "Apply"}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={removeCoupon}
                                  className="px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 rounded-lg transition-all duration-200 flex items-center gap-1"
                                >
                                  <Trash2 className="h-4 w-4" />
                                  Remove
                                </button>
                              )}
                            </div>
                            {appliedCoupon && (
                              <p className="text-xs text-green-600 mt-1">
                                Coupon {appliedCoupon.code} applied! You saved ₹
                                {appliedCoupon.discountAmount?.toLocaleString(
                                  "en-IN",
                                ) || appliedCoupon.discount / 100}
                              </p>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={
                    isSubmitting ||
                    selectedCount === 0 ||
                    Number(paymentAmount) <= 0
                  }
                  className="w-full py-2.5 text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                      <span>Processing...</span>
                    </>
                  ) : (
                    <>
                      <CreditCard className="h-4 w-4" />
                      <span>Proceed to Payment</span>
                    </>
                  )}
                </button>
              </form>
            </div>
          </motion.div>
        </div>
      )}
      {showRazorpayPopup && (
        <RazorpayPopup
          isOpen={showRazorpayPopup}
          onClose={() => setShowRazorpayPopup(false)}
          batchId={remainingDownload ? remainingBatchId : batchId}
          count={selectedCount}
          remainingDownload={remainingDownload}
          remainingSessionId={remainingSessionId}
          totalAmount={paymentAmount}
          originalAmount={originalAmount}
          couponCode={appliedCoupon?.code || null}
          userDetails={userFormDetails}
          onPaymentSuccess={(paymentData) => {
            toast.success(
              "Payment successful! Your download will start shortly.",
            );
            if (remainingDownload) {
              remainingDownloadSuccess();
            }
          }}
        />
      )}

      {showStripePopup && (
        <StripePopup
          isOpen={showStripePopup}
          onClose={() => setShowStripePopup(false)}
          batchId={remainingDownload ? remainingBatchId : batchId}
          remainingDownload={remainingDownload}
          remainingSessionId={remainingSessionId}
          count={selectedCount}
          totalAmount={paymentAmount}
          originalAmount={originalAmount}
          couponCode={appliedCoupon?.code || null}
          userDetails={userFormDetails}
          onPaymentSuccess={(paymentData) => {
            toast.success(
              "Payment successful! Your download will start shortly.",
            );
            if (remainingDownload) {
              remainingDownloadSuccess();
            }
          }}
        />
      )}
    </AnimatePresence>
  );
};

export default DownloadDataFormPopup;
